import React, { useState, useContext, useEffect } from "react";

import {
  Grid,
  Link,
  Typography,
  Breadcrumbs,
  TextField,
  IconButton,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { makeStyles } from "@material-ui/core/styles";

import Spinner from "../../layout/Spinner";

import { Alert, AlertTitle } from "@material-ui/lab";
import { alpha } from "@material-ui/core/styles/colorManipulator";

import PaymentFilter from "./PaymentFilter";
import PaymentTable from "./PaymentTable";
import PaymentSummary from "./PaymentSummary";
import PaymentDetails from "./PaymentDetails";

import PaymentContext from "../../../context/paypal/payments/PaymentContext";

const PaymentHome = () => {
  const paymentContext = useContext(PaymentContext);
  const { loading, getUnmatched, getPaymentByID, error } = paymentContext;
  const [paymentItems, setPaymentItems] = useState([]);
  const [checked, setChecked] = useState(false);
  const [checked1, setChecked1] = useState(true);
  const [checked2, setChecked2] = useState(true);
  const [checked3, setChecked3] = useState(true);
  const [checked4, setChecked4] = useState(true);
  const [noUnmatched, setNoUnmatched] = useState(false);
  const [openDetails, setOpenDetails] = useState();
  const [state, setState] = useState({
    search_value: "",
  });
  const [errors, setErrors] = useState({
    error_message: "",
  });

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    buttonOutline: {
      "&:focus": {
        outline: "none",
      },
    },
    errorAlert: {
      width: "40%",
      "& > * + *": {
        marginTop: theme.spacing(5),
      },
      position: "absolute",
    },
    errorAlertColor: {
      backgroundColor: alpha("#ffc2b3", 0.8),
    },
  }));

  const classes = useStyles();

  const ErrorAlert = (message) => {
    setErrors((errors) => ({
      ...errors,
      error_message: message,
    }));
    setTimeout(() => {
      setErrors((errors) => ({
        ...errors,
        error_message: "",
      }));
    }, 4000);
  };

  useEffect(() => {
    if (error && error.data && error.data.error && error.data.error.message) {
      ErrorAlert(error.data.error.message);
    }
  }, [error]);

  const onBreadCrumbCLick = (e) => {
    e.preventDefault();
    if (loading === false) {
      setOpenDetails();
    }
  };

  const onCheckBox = (e) => {
    if (e.target.id === "paypal_express") {
      setChecked1(e.target.checked);
    } else if (e.target.id === "paypal_billing") {
      setChecked2(e.target.checked);
    } else if (e.target.id === "visa") {
      setChecked3(e.target.checked);
    } else if (e.target.id === "master") {
      setChecked4(e.target.checked);
    } else if (e.target.id === "unmatched") {
      getUnmatched(e.target.checked);
      setChecked(e.target.checked);
    }
  };

  const onSearchChange = (e) => {
    e.preventDefault();
    e.persist();

    if (e.target.id === "search_value") {
      const value = e.target.value.trim();
      setState((state) => ({
        ...state,
        [e.target.id]: value,
      }));
    }
  };

  const [searchIndex, setSearchIndex] = useState("");

  const onSearch = (e) => {
    e.preventDefault();
    if (state.search_value !== searchIndex) {
      getPaymentByID(state.search_value);
      setChecked(false);
      setSearchIndex(state.search_value);
    }
  };

  return (
    <div className={classes.root}>
      <Grid container direction="row" justifyContent="center">
        {" "}
        {errors.error_message ? (
          <div className={classes.errorAlert}>
            <Alert severity="error" className={classes.errorAlertColor}>
              {" "}
              <AlertTitle>
                <strong> Alert </strong>{" "}
              </AlertTitle>{" "}
              {errors.error_message}{" "}
            </Alert>{" "}
          </div>
        ) : null}{" "}
      </Grid>{" "}
      <Grid container direction="column" spacing={1}>
        <Grid container spacing={0} justifyContent="flex-start">
          <Grid item xs={12}>
            <Typography variant="h4"> Payment </Typography>{" "}
          </Grid>{" "}
          <Grid item xs={12}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit" href="/" onClick={onBreadCrumbCLick}>
                Payment{" "}
              </Link>{" "}
              {openDetails ? (
                <Link color="inherit"> {openDetails.id} </Link>
              ) : null}{" "}
            </Breadcrumbs>{" "}
          </Grid>{" "}
        </Grid>{" "}
        <Grid item xs={12}>
          {" "}
          {openDetails ? (
            <PaymentDetails openDetails={openDetails} />
          ) : (
            <Grid container direction="column" spacing={1}>
              <Grid item xs={12}>
                <PaymentFilter
                  setPaymentItems={setPaymentItems}
                  checked={checked}
                  setChecked={setChecked}
                  state={state}
                  setChecked1={setChecked1}
                  setChecked2={setChecked2}
                  setChecked3={setChecked3}
                  setChecked4={setChecked4}
                />{" "}
              </Grid>{" "}
              <Grid item xs={12}>
                <Typography variant="h5"> Summary </Typography>{" "}
              </Grid>{" "}
              <Grid item xs={12}>
                <PaymentSummary
                  paymentItems={paymentItems}
                  setNoUnmatched={setNoUnmatched}
                  checked1={checked1}
                  checked2={checked2}
                  checked3={checked3}
                  checked4={checked4}
                />{" "}
              </Grid>{" "}
              <Grid item xs={12}>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="flex-end"
                >
                  <Grid item>
                    <Typography variant="h5"> Payments </Typography>{" "}
                  </Grid>{" "}
                  <Grid item>
                    <Grid container direction="row" spacing={2}>
                      <Grid item>
                        <Grid
                          container
                          direction="row"
                          alignItems="flex-end"
                          style={{
                            height: "100%",
                          }}
                        >
                          <Grid item>
                            <FormControlLabel
                              style={{
                                height: 15,
                              }}
                              onChange={onCheckBox}
                              control={
                                <Checkbox
                                  id="paypal_express"
                                  checked={checked1}
                                  style={{
                                    pointerEvents: "none",
                                  }}
                                  color="primary"
                                  disabled={loading}
                                />
                              }
                              label="Paypal Express"
                            />
                          </Grid>{" "}
                          <Grid item>
                            <FormControlLabel
                              style={{
                                height: 15,
                              }}
                              onChange={onCheckBox}
                              control={
                                <Checkbox
                                  id="paypal_billing"
                                  checked={checked2}
                                  style={{
                                    pointerEvents: "none",
                                  }}
                                  color="primary"
                                  disabled={loading}
                                />
                              }
                              label="Paypal Billing"
                            />
                          </Grid>{" "}
                          <Grid item>
                            <FormControlLabel
                              style={{
                                height: 15,
                              }}
                              onChange={onCheckBox}
                              control={
                                <Checkbox
                                  id="visa"
                                  checked={checked3}
                                  style={{
                                    pointerEvents: "none",
                                  }}
                                  color="primary"
                                  disabled={loading}
                                />
                              }
                              label="Visa"
                            />
                          </Grid>{" "}
                          <Grid item>
                            <FormControlLabel
                              style={{
                                height: 15,
                              }}
                              onChange={onCheckBox}
                              control={
                                <Checkbox
                                  id="master"
                                  checked={checked4}
                                  style={{
                                    pointerEvents: "none",
                                  }}
                                  color="primary"
                                  disabled={loading}
                                />
                              }
                              label="Master"
                            />
                          </Grid>{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                      <Grid item>
                        <Grid
                          container
                          direction="row"
                          alignItems="flex-end"
                          style={{
                            height: "100%",
                          }}
                        >
                          <FormControlLabel
                            style={{
                              height: 15,
                            }}
                            onChange={onCheckBox}
                            control={
                              <Checkbox
                                id="unmatched"
                                checked={checked}
                                style={{
                                  pointerEvents: "none",
                                }}
                                color="primary"
                                disabled={noUnmatched || loading}
                              />
                            }
                            label="Unmatched"
                          />
                        </Grid>{" "}
                      </Grid>{" "}
                      <Grid item>
                        <Grid container direction="row">
                          <Grid item>
                            <TextField
                              label="Search by Transaction ID"
                              type="text"
                              id="search_value"
                              name="search_value"
                              size="small"
                              disabled={loading}
                              style={{
                                width: 250,
                              }}
                              value={state.search_value}
                              onChange={onSearchChange}
                            />{" "}
                          </Grid>{" "}
                          <Grid item>
                            <IconButton
                              color="primary"
                              style={{
                                height: "100%",
                              }}
                              disabled={loading || state.search_value === ""}
                              onClick={onSearch}
                              className={classes.buttonOutline}
                            >
                              <SearchIcon />
                            </IconButton>{" "}
                          </Grid>{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                  </Grid>{" "}
                </Grid>{" "}
              </Grid>{" "}
              <Grid item xs={12}>
                {" "}
                {loading ? (
                  <Grid
                    container
                    direction="column"
                    justifyContent="flex-end"
                    style={{
                      height: 300,
                    }}
                  >
                    <Spinner />
                  </Grid>
                ) : (
                  <PaymentTable
                    paymentItems={paymentItems}
                    setOpenDetails={setOpenDetails}
                    checked1={checked1}
                    checked2={checked2}
                    checked3={checked3}
                    checked4={checked4}
                  />
                )}{" "}
              </Grid>{" "}
            </Grid>
          )}{" "}
        </Grid>{" "}
      </Grid>{" "}
    </div>
  );
};

export default PaymentHome;
